module.exports = __webpack_public_path__ + "img/68.1.998c1627.jpg";